import {lazy} from 'react';
import {isWeb} from '../constants';

const WEB_CHUNK_RETRY_COUNT = 3;
const WEB_CHUNK_RETRY_DELAY_MS = 1000;

async function importWithRetry(importFn) {
  let lastError;

  for (let attempt = 0; attempt <= WEB_CHUNK_RETRY_COUNT; attempt++) {
    try {
      return await importFn();
    } catch (error) {
      lastError = error;
      if (attempt < WEB_CHUNK_RETRY_COUNT) {
        await new Promise(resolve =>
          setTimeout(resolve, WEB_CHUNK_RETRY_DELAY_MS * (attempt + 1)),
        );
      }
    }
  }

  throw lastError;
}

export function lazyWithRetry(importFn) {
  if (!isWeb) {
    return lazy(importFn);
  }

  return lazy(() => importWithRetry(importFn));
}
